"use client";

import { createContext } from 'react';
import { User, IdTokenResult } from 'firebase/auth';
import { UserRole } from '../types/auth';

// 인증 컨텍스트 타입 정의
interface AuthContextType {
  user: User | null;                    // 현재 로그인한 사용자
  idTokenResult: IdTokenResult | null;  // 사용자 토큰 정보 (역할 포함)
  loading: boolean;                     // 인증 상태 로딩 중 여부
  role: UserRole | null;                // 사용자 역할
  signIn: (email: string, password: string) => Promise<User>; // 로그인 함수
  signInWithGoogle: () => Promise<User>; // 구글 로그인 함수
  signOut: () => Promise<void>;         // 로그아웃 함수
}

const AuthContext = createContext<AuthContextType>({
  user: null,
  idTokenResult: null,
  loading: true,
  role: null,
  signIn: async () => { throw new Error('signIn function not implemented'); },
  signInWithGoogle: async () => { throw new Error('signInWithGoogle function not implemented'); },
  signOut: async () => { throw new Error('signOut function not implemented'); },
});

export { AuthContext };